import React, { useEffect, useState } from 'react';
import {
  Switch,
  Route,
  withRouter,
} from 'react-router-dom';
import { Menu } from 'antd';
import { SpTab } from 'components/DesignKit';

import Pages from '../PaymentPages/components/PaymentPagesList';
import Checkouts from '../PayamentCheckout/PaymentCheckoutList';
import Donation from '../DonationPages/components/DonationPagesList';
import Events from '../AdminEvents/components/EventsList';
import NonSeated from '../EventPages/EventsList';

type Props = {
  location: {
    pathname: string
  },
};

const PagesList = (props: Props) => {
  const {
    location,
  } = props;
  const [current, setCurrent] = useState('payment');

  const setMenu = (query) => {
    switch (query) {
      case '/pay-links/payment-pages': {
        setCurrent('payment');
        break;
      }
      case '/pay-links/checkout-page': {
        setCurrent('checkout');
        break;
      }
      case '/pay-links/donation-pages': {
        setCurrent('donation');
        break;
      }
      case '/pay-links/events': {
        setCurrent('events');
        break;
      }
      case '/pay-links/event-page/non-seated': {
        setCurrent('nonevents');
        break;
      }
      case '/pay-links/event-page/seated': {
        setCurrent('seatedevents');
        break;
      }
      default:
        setCurrent('payment');
    }
  };

  useEffect(() => {
    setMenu(location.pathname);
  }, [location]);

  return (
    <div>
      <Menu onClick={e => setCurrent(e.key)} selectedKeys={[current]} mode="horizontal" style={{ fontSize: '20px' }}>
        <Menu.Item key="payment">
          <SpTab
            to="/pay-links/payment-pages"
            selected={current === 'payment'}
            fontSize="14px"
          >
            Payment
          </SpTab>
        </Menu.Item>
        <Menu.Item key="checkout">
          <SpTab
            to="/pay-links/checkout-page"
            selected={current === 'checkout'}
            fontSize="14px"
          >
            Checkout
          </SpTab>
        </Menu.Item>
        <Menu.Item key="donation">
          <SpTab
            to="/pay-links/donation-pages"
            selected={current === 'donation'}
            fontSize="14px"
          >
            Donation
          </SpTab>
        </Menu.Item>
        <Menu.Item key="events">
          <SpTab
            to="/pay-links/events"
            selected={current === 'events'}
            fontSize="14px"
          >
            Events
          </SpTab>
        </Menu.Item>
        <Menu.Item key="nonevents">
          <SpTab
            to="/pay-links/event-page/non-seated"
            selected={current === 'nonevents'}
            fontSize="14px"
          >
            Non Seated Events
          </SpTab>
        </Menu.Item>
        <Menu.Item key="seatedevents">
          <SpTab
            to="/pay-links/event-page/seated"
            selected={current === 'seatedevents'}
            fontSize="14px"
          >
            Seated Events
          </SpTab>
        </Menu.Item>
      </Menu>
      <Switch>
        <Route exact path="/pay-links/payment-pages" component={Pages} />
        <Route exact path="/pay-links/checkout-page" component={Checkouts} />
        <Route exact path="/pay-links/donation-pages" component={Donation} />
        <Route exact path="/pay-links/events" component={Events} />
        <Route exact path="/pay-links/event-page/non-seated" component={NonSeated} />
        <Route exact path="/pay-links/event-page/seated" component={NonSeated} />
      </Switch>
    </div>
  );
};

export default withRouter(PagesList);
